import { Injectable } from '@angular/core';
import { GenericService, LoaderConfig } from './generic.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServerResponse } from '../models/ServerResponse';
import { UsersService } from './users.service';
import { ISAPI, ISPagination, MVListingConfigs } from 'is-lib';
import { CreateElectricityGrouping, CreateNaturalGasGrouping, IGrouping } from '../models/Grouping';
import { IGroupingPrice, IPrice } from '../models/Price';
import { ElectricityMeterConsumption, NaturalGasMeterConsumption } from '../models/EnergyConsumptions';

@Injectable({
    providedIn: 'root'
})
export class GroupingsService {
    constructor(
        private _httpService: GenericService, 
        private _userService: UsersService
    ) {}

    //#region GET
    getUserGroupings(body?: ISAPI, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<IGrouping[]>> {
      if (body == null) {
        body = new ISAPI([], new ISPagination(100, 0));
      }
      return this._httpService.post(`${environment.apiUrl}ClientPortalUsers/${this._userService.userCountryCode}/Mine/Groupings`, body, undefined, loaderConfig);
    }

    getGroupings(body?: MVListingConfigs, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<IGrouping[]>> {
      if (body == null) {
        body = new MVListingConfigs([], null, new ISPagination(100, 0));
      }
      return this._httpService.post(`${environment.apiUrl}Groupings/Get`, body, undefined, loaderConfig);
    }

    getGroupingPrices(groupingId: string, body?: ISAPI, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<IPrice[]>> {
      if (!body) {
        body = new ISAPI([], new ISPagination(100, 0));
      }
      
      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/Prices`, body, undefined, loaderConfig);
    }

    getGroupingElectricityGroupings(groupingId: string, body?: ISAPI, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any[]>> {
      if (body == null) {
        body = new ISAPI([], new ISPagination(100, 0));
      }
      
      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/${this._userService.userCountryCode}/ElectricityGroupings`, body, undefined, loaderConfig);
    }

    getGroupingNaturalGasGroupings(groupingId: string, body?: ISAPI, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any[]>> {
      if (body == null) {
        body = new ISAPI([], new ISPagination(100, 0));
      }
      
      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/${this._userService.userCountryCode}/NaturalGasGroupings`, body, undefined, loaderConfig);
    }

    getElectricityGroupingsTotalConsumption(groupingId: string, filters?: ISAPI, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<ElectricityMeterConsumption[]>> {
      let body = filters ?? new ISAPI([], new ISPagination(100, 0));
      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/${this._userService.userCountryCode}/ElectricityGroupings/TotalConsumptions`, body, undefined, loaderConfig);
    }

    getNaturalGasGroupingsTotalConsumption(groupingId: string, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<NaturalGasMeterConsumption[]>> {
      let body = new ISAPI([], new ISPagination(100, 0));
      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/${this._userService.userCountryCode}/NaturalGasGroupings/TotalConsumptions`, body, undefined, loaderConfig);
    }

    getGroupingOpportunities(groupingId: string, body?: MVListingConfigs, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any[]>>{
      if (body == null) {
        body = new MVListingConfigs([], null, new ISPagination(100, 0));
      }

      return this._httpService.post(`${environment.apiUrl}Groupings/${groupingId}/${this._userService.userCountryCode}/Opportunities/Get`, body, undefined, loaderConfig);
    }
    //#endregion

    // #region POST
    createElectricityGrouping(body: CreateElectricityGrouping, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
      return this._httpService.post(`${environment.apiUrl}ElectricityGroupings/PT`, body, undefined, loaderConfig);
    }

    createNaturalGasGrouping(body: CreateNaturalGasGrouping, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
      return this._httpService.post(`${environment.apiUrl}NaturalGasGroupings/PT`, body, undefined, loaderConfig);
    }

    addGroupingPriceToElectricityGrouping(electricityGroupingId: string, body: string[], loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
        return this._httpService.post(`${environment.apiUrl}ElectricityGroupings/${this._userService.userCountryCode}/${electricityGroupingId}/GroupingPrices`, body, undefined, loaderConfig);
    }
    addGroupingPriceToNaturalGasGrouping(naturalGasGroupingId: string, body: string[], loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
        return this._httpService.post(`${environment.apiUrl}NaturalGasGroupings/${this._userService.userCountryCode}/${naturalGasGroupingId}/GroupingPrices`, body, undefined, loaderConfig);
    }
    //#endregion
}